// @MX:SPEC: SPEC-ECOUNT-ETL-CRON-CONSOLE-001 §3.3 cronPresets
// @MX:SPEC: SPEC-CHINA-ADMIN-LOCALE-PHASE1-001 영역 A REQ-LOCALE-P1-FE-001~008
// @MX:NOTE: [AUTO] studio crm v2의 cronPresets.ts에서 차용. 5필드(표준) cron 형식 — china-inapi 스케줄러는
// 5필드(분/시/일/월/요일) 사용. studio(BullMQ)의 6필드(초 포함)와 다름에 주의.

import i18n from '@/i18n';

/**
 * ECOUNT ETL 스케줄러 cron 프리셋 — china-inapi SCHEDULER 설정 값과 1:1 매핑
 * 5필드 cron 형식 (분 시 일 월 요일)
 * REQ-LOCALE-P1-FE-001: label → i18nKey 교체 (locale 동적 변환)
 */
export const CRON_PRESETS = [
  { i18nKey: 'ecountEtl_cron_hourly',   value: '0 * * * *' },
  { i18nKey: 'ecountEtl_cron_daily03',  value: '0 3 * * *' },
  { i18nKey: 'ecountEtl_cron_daily06',  value: '0 6 * * *' },
  { i18nKey: 'ecountEtl_cron_daily09',  value: '0 9 * * *' },
  { i18nKey: 'ecountEtl_cron_daily00',  value: '0 0 * * *' },
  { i18nKey: 'ecountEtl_cron_every6h',  value: '0 */6 * * *' },
  { i18nKey: 'ecountEtl_cron_every12h', value: '0 */12 * * *' },
];

/**
 * cron 표현식을 현재 locale의 사람이 읽기 편한 라벨로 변환
 * 프리셋에 없으면 raw cron 문자열 반환
 * REQ-LOCALE-P1-FE-002~004, REQ-LOCALE-P1-FE-007 (lazy i18n.global.t() 호출)
 *
 * @param {string} cronExpr - cron 표현식 (5필드)
 * @returns {string} locale 번역된 라벨 또는 raw cron 문자열
 */
export function cronToLabel(cronExpr) {
  // REQ-LOCALE-P1-FE-004: null/undefined/빈 문자열 → '—'
  if (!cronExpr) return '—';
  const match = CRON_PRESETS.find(p => p.value === cronExpr);
  // REQ-LOCALE-P1-FE-003: 프리셋 미매치 → raw cron 문자열
  if (!match) return cronExpr;
  // REQ-LOCALE-P1-FE-002, REQ-LOCALE-P1-FE-007: lazy 호출 (함수 본문 안에서만)
  return i18n.global.t(match.i18nKey);
}
